import { MapPin, Clock } from "lucide-react";
import { EncabezadoSeccion, Reveal } from "../../shared/motion";

export default function Eventos({ datos, seccion }) {
  const eventos = datos.eventos || [];
  if (eventos.length === 0) return null;

  return (
    <section className="bt-seccion" aria-label={seccion.titulo}>
      <div className="bt-seccion-interior">
        <EncabezadoSeccion p="bt" etiqueta={seccion.etiqueta} titulo={seccion.titulo} testid="bt-titulo-eventos" />
        <div className="bt-eventos-lista">
          {eventos.map((ev, i) => (
            <Reveal key={ev.id || i} delay={i * 0.08}>
              <article className="bt-evento" data-testid={`bt-evento-${ev.id || i}`}>
                <p className="bt-evento-hora">{ev.horario}</p>
                <div className="bt-evento-cuerpo">
                  <p className="bt-evento-etiqueta">{ev.etiqueta}</p>
                  <h3 className="bt-evento-nombre">{ev.lugar}</h3>
                  <p className="bt-evento-detalle">
                    <MapPin strokeWidth={1.5} />
                    <span>{ev.direccion}</span>
                  </p>
                  {ev.urlUbicacion && (
                    <a
                      className="bt-boton"
                      href={ev.urlUbicacion}
                      target="_blank"
                      rel="noopener noreferrer"
                      data-testid={`bt-boton-ubicacion-${ev.id || i}`}
                    >
                      <MapPin strokeWidth={1.5} />
                      {ev.textoBoton || "Cómo llegar"}
                    </a>
                  )}
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
